// panel_manager_controller.js
import {Controller} from "@hotwired/stimulus";

export default class extends Controller {
    static targets = ["desktopContainer", "mobileContainer"];
    // You might add more targets if you want to control specific panels within desktop/mobile
    // static targets = ["desktopContainer", "mobileContainer", "editorPanelDesktop", "cropperPanelDesktop", "editorPanelMobile", "cropperPanelMobile"];

    connect() {
        console.log("Panel Manager Stimulus Controller connected! 🖥️📱");
        this.checkScreenSize();
        window.addEventListener("resize", this.checkScreenSize.bind(this)); // Re-check on resize
    }

    disconnect() {
        window.removeEventListener("resize", this.checkScreenSize.bind(this));
    }

    checkScreenSize() {
        // Bootstrap's 'lg' breakpoint is typically 992px
        // Using window.matchMedia for responsive logic
        if (window.matchMedia("(min-width: 992px)").matches) {
            // Large screen or wider
            this.desktopContainerTarget.classList.remove("d-none");
            this.mobileContainerTarget.classList.add("d-none");
        } else {
            // Smaller than large screen (mobile/tablet)
            this.desktopContainerTarget.classList.add("d-none");
            this.mobileContainerTarget.classList.remove("d-none");
        }
    }

    /**
     * Example method to show a specific panel within the active container.
     * This would typically be triggered by an action (e.g., clicking a button).
     * @param {string} panelId - The ID of the panel to show (e.g., 'editor-menu-desktop', 'cropper-menu-mobile')
     */
    showPanel(panelId) {
        // Determine if we're on desktop or mobile layout
        const isDesktop = window.matchMedia("(min-width: 992px)").matches;
        const currentContainer = isDesktop ? this.desktopContainerTarget : this.mobileContainerTarget;

        // Hide all panels within the current active container (if they have a common class or are children)
        // This requires your panels to have a consistent structure or a common parent/class.
        // For simplicity, let's assume they are direct children divs of the containers or have common class 'panel-item'
        Array.from(currentContainer.children).forEach(child => {
            if (child.id && (child.id.includes('editor-menu') || child.id.includes('cropper-menu'))) {
                child.style.display = 'none'; // Or add 'd-none' class
            }
        });

        // Show the target panel
        const targetPanel = currentContainer.querySelector(`#${panelId}`);
        if (targetPanel) {
            targetPanel.style.display = 'block'; // Or remove 'd-none' class
            console.log(`Showing panel: ${panelId}`);
        } else {
            console.warn(`Panel with ID "${panelId}" not found in current view.`);
        }
    }

    // Example action methods that would call showPanel
    showEditorPanel() {
        const suffix = window.matchMedia("(min-width: 992px)").matches ? "desktop" : "mobile";
        this.showPanel(`editor-menu-${suffix}`);
    }

    showCropperPanel() {
        const suffix = window.matchMedia("(min-width: 992px)").matches ? "desktop" : "mobile";
        this.showPanel(`cropper-menu-${suffix}`);
    }
}